import React, { useEffect, useState } from "react";
import { Input } from "./ui/input";
import { hindiSuggestions } from "../lib/translit";

// Text input that shows 2-3 Hindi spelling options below while typing Hinglish.
export const HindiInput = ({ value, onChange, testid, ...rest }) => {
  const [opts, setOpts] = useState([]);

  useEffect(() => {
    if (!/[A-Za-z]/.test(value || "")) {
      setOpts([]);
      return undefined;
    }
    let live = true;
    const t = setTimeout(async () => {
      const o = await hindiSuggestions(value);
      if (live) setOpts(o);
    }, 450);
    return () => {
      live = false;
      clearTimeout(t);
    };
  }, [value]);

  return (
    <div>
      <Input data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} {...rest} />
      {opts.length > 0 && (
        <div data-testid={`${testid}-suggestions`} className="flex flex-wrap items-center gap-1.5 mt-1.5">
          <span className="text-[10px] text-[#9a7a5a] font-dev">हिंदी में कैसे दिखे?</span>
          {opts.map((o, i) => (
            <button
              type="button"
              key={o}
              data-testid={`${testid}-opt-${i}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onChange(o)}
              className="px-2.5 py-1 rounded-full text-sm font-dev bg-[#f3ead6] border border-[#6e1b1b]/40 text-[#5e1414] hover:bg-[#6e1b1b] hover:text-[#f3ead6] transition-colors"
            >
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
